import { useQuery } from '@tanstack/react-query';
import { api, type ExploreComicsParams, type ExploreStoriesParams } from '../services/api';

export function useComicByShareCode(shareCode: string | undefined) {
  return useQuery({
    queryKey: ['comic', 'share', shareCode],
    queryFn: () => api.getComicByShareCode(shareCode!),
    enabled: !!shareCode,
  });
}

export function useFeaturedComics() {
  return useQuery({
    queryKey: ['comics', 'featured'],
    queryFn: () => api.getFeaturedComics(),
    staleTime: 5 * 60_000,
  });
}

export function useExploreComics(params: ExploreComicsParams) {
  return useQuery({
    queryKey: ['comics', 'explore', params],
    queryFn: () => api.getExploreComics(params),
    staleTime: 60_000,
  });
}

export function useExploreStories(params: ExploreStoriesParams) {
  return useQuery({
    queryKey: ['stories', 'explore', params],
    queryFn: () => api.getExploreStories(params),
    staleTime: 60_000,
  });
}

export function useLanguages() {
  return useQuery({
    queryKey: ['languages'],
    queryFn: () => api.getLanguages(),
    staleTime: 5 * 60_000,
  });
}

export function useMyComics(enabled: boolean) {
  return useQuery({
    queryKey: ['comics', 'mine'],
    queryFn: () => api.getMyComics(),
    enabled,
  });
}

export function useMyStories(enabled: boolean) {
  return useQuery({
    queryKey: ['stories', 'mine'],
    queryFn: () => api.getMyStories(),
    enabled,
  });
}

export function useMyAdventures(enabled: boolean) {
  return useQuery({
    queryKey: ['adventures', 'mine'],
    queryFn: () => api.getMyAdventures(),
    enabled,
  });
}
